import { MutationTree } from 'vuex';
import { ISelectedPageFieldIds } from '../types/selected-page-field-ids';
import { IFieldState } from '@/fields/store/field.store';
import { IField } from '@/fields/types/field';

export const mutationSetLoading = 'setLoading';
export const mutationSetDocumentId = 'setDocumentId';
export const mutationSetPageWidth = 'setPageWidth';

export const mutationSetFields = 'setFields';
export const mutationAddFields = 'addFields';
export const mutationDeleteFields = 'deleteFields';
export const mutationUpdateField = 'updateField';
export const mutationUpdateFieldDone = 'updateFieldDone';
export const mutationSetFieldId = 'setFieldId';

export const mutationSetSelectedFields = 'setSelectedFields';
export const mutationSelectField = 'selectField';
export const mutationSetSelectedPageFieldIds = 'setSelectedPageFieldIds';
export const mutationDeselectField = 'deselectField';
export const mutationDeselectAllFields = 'deselectAllFields';

export const mutationSetFocusedFieldId = 'setFocusedFieldId';
export const mutationSetSenderSignature = 'setSenderSignature';

export const mutationSetTabFieldId = 'setTabFieldId';

export const mutationSetLastUpdatedFieldId = 'setLastUpdatedFieldId';

export const mutationSetSelectBoxFields = 'setSelectBoxFields';

export const mutations: MutationTree<IFieldState> = {
  [mutationSetLoading](state: IFieldState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetDocumentId](state: IFieldState, documentId: string) {
    state.documentId = documentId;
  },
  [mutationSetFields](state: IFieldState, fields: IField[]) {
    state.fields = fields;
  },
  [mutationAddFields](state: IFieldState, fields: IField[]) {
    state.fields = [...state.fields, ...fields];
  },
  [mutationUpdateField](state: IFieldState, field: IField) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.pageId === field.pageId && stateField.id === field.id ? field : stateField
    );
  },
  [mutationUpdateFieldDone](
    state: IFieldState,
    { field, tempId }: { field: IField; tempId: string }
  ) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.pageId === field.pageId && stateField.id === tempId ? field : stateField
    );
  },
  [mutationSelectField](state: IFieldState, field: IField) {
    if (!state.selectedPageFieldIds.pageId) {
      state.selectedPageFieldIds.pageId = field.pageId;
    }

    if (
      state.selectedPageFieldIds.pageId === field.pageId &&
      !state.selectedPageFieldIds.fieldIds.includes(field.id)
    ) {
      state.selectedPageFieldIds.fieldIds.push(field.id);
    }
  },
  [mutationSetSelectedPageFieldIds](
    state: IFieldState,
    selectedPageFieldIds: ISelectedPageFieldIds
  ) {
    state.selectedPageFieldIds = selectedPageFieldIds;
  },
  [mutationDeselectField](state: IFieldState, field: IField) {
    state.selectedPageFieldIds.fieldIds = state.selectedPageFieldIds.fieldIds.filter(
      (id: string) => id !== field.id
    );
    if (state.selectedPageFieldIds.fieldIds.length === 0) {
      state.selectedPageFieldIds.pageId = null;
    }
  },
  [mutationSetSelectedFields](state: IFieldState, selectedFields: IField[]) {
    state.selectedPageFieldIds.fieldIds = selectedFields.map((field: IField) => field.id);
  },
  [mutationDeleteFields](state: IFieldState, fieldIds: string[]) {
    const updatedFields: IField[] = state.fields.filter(
      (stateField: IField) => !fieldIds.includes(stateField.id)
    );
    state.fields = updatedFields;
  },
  [mutationDeselectAllFields](state: IFieldState) {
    state.selectedPageFieldIds.pageId = null;
    state.selectedPageFieldIds.fieldIds = [];
  },
  [mutationSetPageWidth](state: IFieldState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [mutationSetFocusedFieldId](state: IFieldState, fieldId: string) {
    state.focusedFieldId = fieldId;
  },
  [mutationSetFieldId](state: IFieldState, { field, id }: { field: IField; id: string }) {
    state.fields = state.fields.map((stateField: IField) =>
      JSON.stringify(stateField) === JSON.stringify(field) ? { ...stateField, id } : stateField
    );
  },
  [mutationSetSenderSignature](state: IFieldState, senderSignature: string) {
    state.senderSignature = senderSignature;
  },
  [mutationSetTabFieldId](state: IFieldState, tabFieldId: string) {
    state.tabFieldId = tabFieldId;
  },
  [mutationSetLastUpdatedFieldId](state: IFieldState, fieldId: string) {
    state.lastUpdatedFieldId = fieldId;
  },
  [mutationSetSelectBoxFields](state: IFieldState, selectedPageFieldIds: ISelectedPageFieldIds) {
    state.markedPageFieldIds = { ...selectedPageFieldIds };
  },
};
